// Colour swatches on a product card. Previewing a colour swaps the card image;
// the swatch itself is a plain link, so navigation needs no JS.
// A custom element rather than a DOMContentLoaded pass: facets.js re-renders the
// product grid with innerHTML, which upgrades custom elements but never re-runs
// <script> tags.
class CardSwatches extends HTMLElement {
  connectedCallback() {
    this.card = this.closest('.product-card-wrapper');
    this.image = this.card?.querySelector('.card__media img:first-child');
    this.swatches = this.querySelectorAll('[data-card-swatch]');

    if (!this.card || !this.image || this.swatches.length === 0) return;

    this.original = {
      src: this.image.getAttribute('src'),
      srcset: this.image.getAttribute('srcset'),
      alt: this.image.getAttribute('alt'),
    };

    // Swatches with no image of their own still get handlers: moving onto one has
    // to clear the previous swatch's image rather than leave the wrong colour up.
    this.swatches.forEach((swatch) => {
      swatch.addEventListener('mouseenter', () => this.preview(swatch));
      swatch.addEventListener('focus', () => this.preview(swatch));
    });

    this.addEventListener('mouseleave', () => this.reset());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.reset();
    });
  }

  preview(swatch) {
    if (!swatch.dataset.cardMediaSrc) {
      this.reset();
      return;
    }

    // Pins the primary image so Dawn's hover-to-secondary-image does not fight it.
    this.card.classList.add('card-wrapper--swatch-hover');
    this.image.setAttribute('src', swatch.dataset.cardMediaSrc);
    this.image.setAttribute('srcset', swatch.dataset.cardMediaSrcset || swatch.dataset.cardMediaSrc);
    if (swatch.dataset.cardMediaAlt) this.image.setAttribute('alt', swatch.dataset.cardMediaAlt);
  }

  reset() {
    this.card.classList.remove('card-wrapper--swatch-hover');
    ['src', 'srcset', 'alt'].forEach((attribute) => {
      const value = this.original[attribute];
      if (value === null) this.image.removeAttribute(attribute);
      else this.image.setAttribute(attribute, value);
    });
  }
}

if (!customElements.get('card-swatches')) {
  customElements.define('card-swatches', CardSwatches);
}
